module.exports = __webpack_public_path__ + "static/media/training-education.073f6144.png";